import styled from 'styled-components';

export const UserProfileContainerStyled = styled.div`
  .filter_layout {
    margin-bottom: 1rem;
  }
`;
